export const LOAD_CLINICS = "LOAD_CLINICS";
export const LOAD_CLINIC = "LOAD_CLINIC";
export const CREATE_CLINIC = "CREATE_CLINIC";
export const CLONE_CLINIC = "CLONE_CLINIC";
export const EDIT_CLINIC_CLINICIANS = "EDIT_CLINIC_CLINICIANS";
export const ADD_UNKNOWN_EMPLOYEE_MODEL = "ADD_UNKNOWN_EMPLOYEE_MODEL";
export const SEARCH_FOR_EMPLOYEE = "SEARCH_FOR_EMPLOYEE";

export const LOAD_CLINICS_SUCCESS = "LOAD_CLINICS_SUCCESS";

export const LOAD_CLINIC_SUCCESS = "LOAD_CLINIC_SUCCESS";

export const CREATE_CLINIC_SUCCESS = "CREATE_CLINIC_SUCCESS";

export const EDIT_CLINIC_CLINICIANS_SUCCESS = "EDIT_CLINIC_CLINICIANS_SUCCESS";

export const CREATE_CLINIC_ERROR = "CREATE_CLINIC_ERROR";

export const EDIT_CLINIC_CLINICIANS_ERROR = "EDIT_CLINIC_CLINICIANS_ERROR";

export const EDIT_CLINIC = "EDIT_CLINIC";
export const EDIT_CLINIC_SUCCESS = "EDIT_CLINIC_SUCCESS";

export const BLOCK_CLINIC = "BLOCK_CLINIC";
export const BLOCK_CLINIC_SUCCESS = "BLOCK_CLINIC_SUCCESS";

export const ADD_RECALL_CASES_TO_MOBILE_CLINIC = "ADD_RECALL_CASES_TO_MOBILE_CLINIC";
export const ADD_RECALL_CASES_TO_MOBILE_CLINIC_SUCCESS = "ADD_RECALL_CASES_TO_MOBILE_CLINIC_SUCCESS";

export const ADD_RECALL_CASE_TO_MOBILE_CLINIC = "ADD_RECALL_CASE_TO_MOBILE_CLINIC";
export const ADD_RECALL_CASE_TO_MOBILE_CLINIC_SUCCESS = "ADD_RECALL_CASE_TO_MOBILE_CLINIC_SUCCESS";
